import React, { FC, useEffect } from 'react';

import { useDispatch } from 'react-redux';

// Reset the AllowList form (previously reset the Setup/Environment slice by mistake).
import { actions } from '../slice';

import { AllowListWizard } from './AllowListWizard';

interface Props {}

export const CreateAllowList: FC<Props> = props => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.resetFormData());
  }, [dispatch]);

  return <AllowListWizard actionType="Create" />;
};
